import { defineStore } from "pinia";
const useProductMediaCenterStoreStore = defineStore("productMediaCenterStore", {
  state: () => ({}),
  getters: {},
  actions: {}
});
export {
  useProductMediaCenterStoreStore as default
};
//# sourceMappingURL=productMediaCenterStore.mjs.map
